import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { useLocation } from 'react-router-dom';
import HeaderTab from './HeaderTab';
import useMessageService from '../../services/i18n/useMessageService';
import { AuthenticatedPaths } from '../../constants/Paths';

const HeaderTabList = ({ userSessionContext }) => {
    const { pathname } = useLocation();
    const [[systemsLabel, myAccountLabel, studiesLabel]] = useMessageService([
        'home.systems',
        'my_account.my_account',
        'home.studies',
    ]);

    return (
        <nav
            css={css`
                height: 100%;
            `}
        >
            <ul
                css={css`
                    display: flex;
                    margin: 0;
                    height: 100%;
                    gap: 2.3333rem;
                    padding: 0;
                `}
            >
                {userSessionContext?.showStudiesTab && (
                    <HeaderTab
                        label={studiesLabel}
                        path={AuthenticatedPaths.STUDIES}
                        selected={pathname.startsWith(AuthenticatedPaths.STUDIES)}
                    />
                )}
                <HeaderTab
                    label={systemsLabel}
                    path={AuthenticatedPaths.SYSTEMS}
                    selected={pathname.startsWith(AuthenticatedPaths.SYSTEMS)}
                />
                <HeaderTab
                    label={myAccountLabel}
                    path={AuthenticatedPaths.MY_ACCOUNT}
                    selected={pathname.startsWith(AuthenticatedPaths.MY_ACCOUNT)}
                />
            </ul>
        </nav>
    );
};

HeaderTabList.propTypes = {
    userSessionContext: PropTypes.shape({
        enableVeevaIdUsernameUpdate: PropTypes.bool,
        handleResponseSessionErrors: PropTypes.func,
        loading: PropTypes.bool,
        showStudiesTab: PropTypes.bool,
        systemsData: PropTypes.arrayOf(
            PropTypes.shape({
                appRedirectUrl: PropTypes.string,
                companyIdentifier: PropTypes.string,
                companyName: PropTypes.string,
                description: PropTypes.string,
                features: PropTypes.arrayOf(PropTypes.string),
                lastLogin: PropTypes.instanceOf(Date),
                lastLoginFormatted: PropTypes.string,
                name: PropTypes.string,
            }),
        ),
    }),
};

export default HeaderTabList;
